import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@zarafront/lib-zds";
import ArrowBackButton from "src/components/Layout/common/ArrowBackButton";
import SidebarLayout from "./components/SidebarLayout";
import "./page-layout.scss";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

const PageLayout = ({ children, className }: PageLayoutProps) => {
  const { t } = useTranslation();

  const scrollToContent = () => {
    const el = document.getElementById("page-layout-content");
    if (el) {
      el.setAttribute("tabindex", "-1");
      el.focus({ preventScroll: true });
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const removeTabIndex = () => {
      const el = document.getElementById("page-layout-content");
      if (el && el.getAttribute("tabindex") === "-1") {
        el.removeAttribute("tabindex");
      }
    };

    document.addEventListener("click", removeTabIndex, true);
    return () => document.removeEventListener("click", removeTabIndex, true);
  }, []);

  return (
    <div className={`page-layout ${className || ""}`}>
      <Button variant="primary" className="skip-link" onClick={scrollToContent}>
        {t("skip_to_main_content")}
      </Button>
      <div className="page-layout__body">
        <header className="page-layout__header">
          <ArrowBackButton />
        </header>
        <aside className="page-layout__aside">
          <SidebarLayout />
        </aside>
        <div id="page-layout-content" className="page-layout__container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
